
  import vueKanban from 'vue-kanban';
import { Component, Vue, Watch } from 'vue-property-decorator';

  import { EnumModel, JobItemTypeEnums } from '@/common/enumerations';
import {
  Client,
  IEmployeeModel,
  IJobItemModel,
  IJobItemScheduleModel,
  JobItemScheduleModel,
  JobItemScheduleSequenceModel,
  JobItemUpdateScheduleModel,
  ScheduledJobItemModel,
  UnscheduledJobItemModel
} from '@/services/api.service';
import { DayColumn, DayColumnType, JobScheduleItem } from './ScheduleModels';

  import ScheduleCard from './ScheduleCard.vue';
import AssignEmployee from './processes/AssignEmployee.vue';
import CancelJobItem from './processes/CancelJobItem.vue';
import RescheduleJobItem from './processes/RescheduleJobItem.vue';

  import toJobItemTypeFormatter from '@/filters/jobitemtype.formatter';
import toDateFormatter from '@/filters/todate.formatter';
import * as DateUtils from '@/utilities/date.utils';
import * as StringUtils from '@/utilities/string.utils';
import { Guid } from 'guid-typescript';

  const MAX_SEQUENCE_NUMBER = 10000;


  export class SimpleListModel {
    public text: string = '';
    public value: string = '';

    constructor(data?: any) {
      if (data) {
        for (const property in data) {
          if (data.hasOwnProperty(property)) { (this as any)[property] = (data as any)[property]; }
        }
      }
    }
  }

  Vue.use(vueKanban);

  @Component({
    filters: {
      toDate: toDateFormatter,
      toJobItemType: toJobItemTypeFormatter
    },
    components: {
      ScheduleCard,
      AssignEmployee,
      RescheduleJobItem,
      CancelJobItem
    }
  })
  export default class Schedule extends Vue {
    public stages: DayColumn[] = [];
    public blocks: JobScheduleItem[] = [];
    public filteredBlocks: JobScheduleItem[] = [];
    public availableWeekStartDates: Date[] = [];
    public selectedWeekStartDate: Date = new Date();
    public showWeekends: boolean = false;
    public showUnscheduled: boolean = true;
    public showFromToday: boolean = true;
    public enableShowFromToday: boolean = true;
    public numberOfWeeksToDisplay: number = 1;
    public availableJobTypes: EnumModel[] = [];
    public jobType: number = 0;

    public isLoading: boolean = false;

    private employees: SimpleListModel[] = [];
    private networks: SimpleListModel[] = [];
    private selectedEmployee: string = '';
    private selectedNetwork: string = '';

    private supressScheduleLoad: boolean = false;

    // tracking vars for edit screens
    private jobItemScheduleInAssignment: JobScheduleItem | null = null;
    private jobItemScheduleInReschedule: JobItemScheduleModel | null = null;
    private jobItemGidInReschedule: string = '';
    private jobGidInReschedule: string = '';
    private jobItemScheduleInCancel: JobItemScheduleModel | null = null;
    private jobItemGidInCancel: string = '';
    private jobGidInCancel: string = '';
    private jobItemNameInCancel: string = '';

    // tracking vars for drag-and-drop confirmation
    private pendingMoveBlock: JobScheduleItem | null = null;
    private pendingMoveNewStatus: string = '';
    private pendingMoveOldStatus: string = '';

    // local cache
    private dataSourceScheduledJobItems: ScheduledJobItemModel[] = [];
    private dataSourceUnscheduledJobItems: UnscheduledJobItemModel[] = [];

    protected mounted() {
      // this.supressScheduleLoad = true;
      const pickJobTypeModel: EnumModel = new EnumModel('(Any Job Type)', 0);
      this.availableJobTypes.push(
        ...JobItemTypeEnums.sort((n1, n2) => StringUtils.stringCompare(n1.name || '', n2.name || ''))
      );
      this.availableJobTypes.unshift(pickJobTypeModel);

      this.selectedWeekStartDate = this.buildDateList(8, 12);

      const employeesPlaceholder = new SimpleListModel({ text: '(All Employees)', value: '' });
      const networkPlaceholder: SimpleListModel = new SimpleListModel({ text: '(All Networks)', value: '' });

      this.employees = [employeesPlaceholder];
      this.networks = [networkPlaceholder];

      // this.processQueryString();
      this.loadData();
    }
    // private queryStartFrom: Date | null = null;
    // private queryDisplayWeeks: number = 1;
    // private queryJobType: number = 0;
    // private queryNetwork: string = '';
    // private queryEmployee: string = '';
    // private queryFromToday: boolean | null = null;
    // private queryShowUnscheduled: boolean | null = null;
    // private queryShowWeekends: boolean | null = null;
    // private queryExecuteSearch: boolean = false;
    // private processQueryString() {
    //   let executeSearch: boolean = false;
    //   const startFrom: string = this.$route.query.from as string;
    //   if (startFrom !== null && startFrom !== undefined) {
    //     // locate the best guess date
    //     this.queryStartFrom = new Date(startFrom as string);
    //     executeSearch = true;
    //   }

    //   const displayWeeks: string = this.$route.query.display as string;
    //   if (displayWeeks !== null && displayWeeks !== undefined) {
    //     this.queryDisplayWeeks = parseInt(displayWeeks as string, 10);
    //     executeSearch = true;
    //   }

    //   const jobtype: string = this.$route.query.jobtype as string;
    //   if (jobtype !== null && jobtype !== undefined) {
    //     this.queryJobType = parseInt(jobtype as string, 10);
    //     executeSearch = true;
    //   }

    //   const network: string = this.$route.query.network as string;
    //   if (network !== null && network !== undefined) {
    //     this.queryNetwork = network as string;
    //     executeSearch = true;
    //   }

    //   const employee: string = this.$route.query.employee as string;
    //   if (employee !== null && employee !== undefined) {
    //     this.queryEmployee = employee as string;
    //     executeSearch = true;
    //   }

    //   const fromToday: string = this.$route.query.fromtoday as string;
    //   if (fromToday !== null && fromToday !== undefined) {
    //     this.queryFromToday = (fromToday as unknown) as boolean;
    //     executeSearch = true;
    //   }

    //   const showUnscheduled: string = this.$route.query.unscheduled as string;
    //   if (showUnscheduled !== null && showUnscheduled !== undefined) {
    //     this.queryShowUnscheduled = (showUnscheduled as unknown) as boolean;
    //     executeSearch = true;
    //   }

    //   const showWeekends: string = this.$route.query.weekends as string;
    //   if (showWeekends !== null && showWeekends !== undefined) {
    //     this.queryShowWeekends = (showWeekends as unknown) as boolean;
    //     executeSearch = true;
    //   }

    //   this.queryExecuteSearch = executeSearch;
    // }

    private async loadData() {
      const clientService = new Client(process.env.VUE_APP_API_URL, this.$http);
      const [theNetworks, theEmployees] = await Promise.all([
        clientService.getNetworks(),
        clientService.getEmployees()
      ]);

      // this.networks = theNetworks;

      const sortedData = theEmployees.sort((n1, n2) =>
        StringUtils.stringCompare(n1.firstName || '', n2.firstName || '')
      );
      const employeesPlaceholder = new SimpleListModel({ text: '(All Employees)', value: '' });

      this.employees = sortedData.map(e => this.getEmployeeAsSimpleListModel(e));
      this.employees.unshift(employeesPlaceholder);
      this.selectedEmployee = '';

      const pickNetworkModel: SimpleListModel = new SimpleListModel({ text: '(All Networks)', value: '' });
      const sortedNetworks = theNetworks.sort((n1, n2) => StringUtils.stringCompare(n1.name || '', n2.name || ''));
      this.networks = sortedNetworks.map(e => new SimpleListModel({ text: e.name, value: e.gid }));
      this.networks.unshift(pickNetworkModel);

      this.selectedNetwork = '';

      

      // Now see if there were query params in place
      // and fill those values
      // if (this.queryExecuteSearch) {
      //   if (this.queryStartFrom) {
      //   }
      //   this.numberOfWeeksToDisplay = this.queryDisplayWeeks;
      //   this.jobType = this.queryJobType;
      //   this.selectedNetwork = this.queryNetwork;
      //   this.selectedEmployee = this.queryEmployee;
      //   if (this.queryShowUnscheduled) {
      //     this.showUnscheduled = this.queryShowUnscheduled;
      //   }
      //   if (this.queryFromToday) {
      //     this.showFromToday = this.queryFromToday;
      //   }
      //   if (this.queryShowWeekends) {
      //     this.showWeekends = this.queryShowWeekends;
      //   }
      // }
      // this.supressScheduleLoad = false;
      this.refreshStages(true, true);
    }

    private getEmployeeAsSimpleListModel(employee: IEmployeeModel) {
      const model = new SimpleListModel({ value: employee.gid });
      model.text = employee.firstName + ' ' + employee.lastName;
      return model;
    }
    get stageNames() {
      return this.stages.map(stage => stage.name);
    }

    private updateEnableShowFromToday() {
      const currentDate = new Date();
          const currentWeek = DateUtils.getWeek(currentDate);
          const selectedWeek = DateUtils.getWeek(this.selectedWeekStartDate);
          if (currentWeek === selectedWeek) {
            console.log('Current week is the same as the selected week start date. Enable show from today.');
            this.enableShowFromToday = true;
          } else {
            console.log('Current week is not the same as the selected week start date. Disable show from today.');
            this.enableShowFromToday = false;
          }
    }

    @Watch('selectedWeekStartDate')
    private onSelectedWeekStartDateChanged(value: Date, oldValue: Date) {
      // does not require underlying data set to change
      this.updateEnableShowFromToday();
      if (!this.supressScheduleLoad) {
        this.refreshStages(true, false);
      }
    }

    @Watch('numberOfWeeksToDisplay')
    private onnumberOfWeeksToDisplayChanged(value: number, oldValue: number) {
      // does not require underlying data set to change
      if (!this.supressScheduleLoad) {
        this.refreshStages(true, false);
      }
    }

    @Watch('showWeekends')
    private onShowWeekendsChanged(value: boolean, oldValue: boolean) {
      // does not require underlying data set to change
      if (!this.supressScheduleLoad) {
        this.refreshStages(true, false);
      }
    }

    @Watch('showUnscheduled')
    private onShowUnscheduledChanged(value: boolean, oldValue: boolean) {
      // does not require underlying data set to change
      if (!this.supressScheduleLoad) {
        this.refreshStages(false, false);
      }
    }

    @Watch('showFromToday')
    private onShowFromTodayChanged(value: boolean, oldValue: boolean) {
      // does not require underlying data set to change
      if (!this.supressScheduleLoad) {
        this.refreshStages(true, false);
      }
    }

    @Watch('jobType')
    private onJobTypeChanged(value: number, oldValue: number) {
      // does not require underlying data set to change
      if (!this.supressScheduleLoad) {
        this.refreshStages(false, false);
      }
    }
    @Watch('selectedNetwork')
    private onSelectedNetworkChanged(value: string, oldValue: string) {
      // does not require underlying data set to change
      if (!this.supressScheduleLoad) {
        this.refreshStages(false, false);
      }
    }
    @Watch('selectedEmployee')
    private onSelectedEmployeeChanged(value: string, oldValue: string) {
      // does not require underlying data set to change
      if (!this.supressScheduleLoad) {
        this.refreshStages(false, false);
      }
    }

    // private isQueryObjectMatch(currentQuery: any, newQuery: any) {
    //   if (currentQuery !== null && currentQuery !== undefined) {
    //     if (currentQuery.from !== newQuery.from) {
    //       return false;
    //     }
    //     if (currentQuery.display !== newQuery.display) {
    //       return false;
    //     }
    //     if (currentQuery.jobtype !== newQuery.jobtype) {
    //       return false;
    //     }
    //     if (currentQuery.employee !== newQuery.employee) {
    //       return false;
    //     }
    //     if (currentQuery.network !== newQuery.network) {
    //       return false;
    //     }
    //     if (currentQuery.fromtoday !== newQuery.fromtoday) {
    //       return false;
    //     }
    //     if (currentQuery.unscheduled !== newQuery.unscheduled) {
    //       return false;
    //     }
    //     if (currentQuery.weekends !== newQuery.weekends) {
    //       return false;
    //     }
    //     return true;
    //   } else {
    //     return false;
    //   }
    // }
    private refreshStages(reloadBlocks: boolean, bypassHistoryPush: boolean) {
      
      this.isLoading = true;
      // Clears and rebuilds the stages and blocks
      if (reloadBlocks) {
        this.blocks = [];
        this.filteredBlocks = [];
      }

      this.stages = [];

      let endDay: number = 5;
      if (this.showWeekends) {
        endDay = 7;
      }
      
      // Loop each week, and then each
      let refDate: Date = new Date(this.selectedWeekStartDate);
      if (this.showFromToday) {
        // Check if the current date is in the same week as the selected week start date
        // and if so, use the current date as the reference date. Otherwise, use the selected week start date
        const currentDate = new Date();
        const currentWeek = DateUtils.getWeek(currentDate);
        const selectedWeek = DateUtils.getWeek(this.selectedWeekStartDate);
        if (currentWeek === selectedWeek) {
          refDate = currentDate;
        }
      }
      for (let weekIdx = 0; weekIdx < this.numberOfWeeksToDisplay; weekIdx++) {
        
        
        const weekStartDate = DateUtils.addDays(new Date(refDate), weekIdx * 7);
        // Work out how many days we should be showing
        let daysToShow = 5;
        if (this.showWeekends) {
          daysToShow = 7;
        }
        daysToShow = daysToShow * this.numberOfWeeksToDisplay;
        for (let dayIdx = 0; dayIdx < endDay; dayIdx++) {
          const columnDate = DateUtils.addDays(new Date(weekStartDate), dayIdx);
          // skip if we aren't showing weekends
          if (this.showWeekends || !(columnDate.getDay() === 0 || columnDate.getDay() === 6)) {
            const newColumn = new DayColumn();
            const dayText = '0' + (columnDate.getMonth() + 1);
            newColumn.id = columnDate.getFullYear() + '-' + dayText.slice(-2) + '-' + columnDate.getDate();
            newColumn.name = columnDate.toDateString();
            newColumn.date = columnDate;
            if (columnDate.getDay() === 0 || columnDate.getDay() === 6) {
              newColumn.type = DayColumnType.weekend;
              newColumn.class = 'weekend';
            }
            if (columnDate.getDay() === 1) {
              // newColumn.class = 'firstdayofweek';
            }
            this.stages.push(newColumn);
          } else {
            // increase the end day by one
            endDay++;
          }
          if (this.stages.length >= daysToShow) {
            break;
          }
        }
      }
      if (this.showUnscheduled) {
        const newColumn = new DayColumn();
        newColumn.id = 'unscheduled';
        newColumn.name = 'unscheduled';
        newColumn.class = 'unscheduled';
        newColumn.date = null;
        newColumn.type = DayColumnType.unscheduled;
        this.stages.push(newColumn);
      }

      // push to the router history
      // const searchDate = moment(String(this.selectedWeekStartDate)).format('YYYY-MM-DD');
      // this.$router.push('?startdate=' + searchDate + '&showweekend=' + this.showWeekends + '&numberofweeks=' + this.numberOfWeeksToDisplay + '&showunassigned=' + this.showUnassigned);
      // If we are reset
      if (reloadBlocks) {
        this.reloadJobItems();
        // } else {
        //   this.supressScheduleLoad = false;
        //   console.log('Suppress Schedule Load:', this.supressScheduleLoad);
      } else {
        this.applyJobItemFilter();
        this.isLoading = false;
      }
    }

    private reloadJobItems() {
      this.blocks = [];
      this.filteredBlocks = [];
      // this.getScheduledJobItems();
      // this.getUnscheduledJobItems();
      this.startScheduleLoad();
    }

    private scheduledItemsLoaded: boolean = false;
    private unscheduledItemsLoaded: boolean = false;
    private startScheduleLoad() {
      this.scheduledItemsLoaded = false;
      this.unscheduledItemsLoaded = false;
      this.getScheduledJobItems();
      this.getUnscheduledJobItems();
    }

    private updateScheduleLoadStatus() {
      //console.log('updateScheduleLoadStatus - scheduledItemsLoaded:', this.scheduledItemsLoaded);
      //console.log('updateScheduleLoadStatus - unscheduledItemsLoaded:', this.unscheduledItemsLoaded);
      if (this.scheduledItemsLoaded && this.unscheduledItemsLoaded) {
        // this.supressScheduleLoad = false;
        //console.log('Suppress Schedule Load:', this.supressScheduleLoad);

        // Sort blocks by scheduledDate, then by orderIndex
        this.sortBlocksByScheduleDateAndOrderIndex();

        this.applyJobItemFilter();
        this.isLoading = false;
      }
    }

    private sortBlocksByScheduleDateAndOrderIndex() {
      this.blocks.sort((a, b) => {
        // Items with "unscheduled" status should be sorted last
        const aIsUnscheduled = a.status === 'unscheduled' || a.savedStatus === 'unscheduled' || a.scheduledDate === undefined;
        const bIsUnscheduled = b.status === 'unscheduled' || b.savedStatus === 'unscheduled' || b.scheduledDate === undefined;
        
        // Unscheduled items go to the end
        if (aIsUnscheduled && !bIsUnscheduled) {
          return 1;
        }
        if (!aIsUnscheduled && bIsUnscheduled) {
          return -1;
        }
        if (aIsUnscheduled && bIsUnscheduled) {
          // Both unscheduled - sort by orderIndex if available
          const aIndex = a.orderIndex || MAX_SEQUENCE_NUMBER;
          const bIndex = b.orderIndex || MAX_SEQUENCE_NUMBER;
          return aIndex - bIndex;
        }
        
        // Both are scheduled - sort by date first
        const aDate = a.scheduledDate;
        const bDate = b.scheduledDate;
        
        if (aDate === undefined && bDate === undefined) {
          // Both have no date - sort by orderIndex
          const aOrderIndex = a.orderIndex || MAX_SEQUENCE_NUMBER;
          const bOrderIndex = b.orderIndex || MAX_SEQUENCE_NUMBER;
          return aOrderIndex - bOrderIndex;
        }
        if (aDate === undefined) {
          return 1;
        }
        if (bDate === undefined) {
          return -1;
        }
        
        const dateCompare = aDate.getTime() - bDate.getTime();
        
        if (dateCompare !== 0) {
          return dateCompare;
        }
        
        // Same date - sort by orderIndex
        const aOrderIndex = a.orderIndex || MAX_SEQUENCE_NUMBER;
        const bOrderIndex = b.orderIndex || MAX_SEQUENCE_NUMBER;
        return aOrderIndex - bOrderIndex;
      });
    }
    private buildDateList(previousWeeks: number, forwardWeeks: number): Date {
      // Get the current date, find the last Monday,
      // cycle back 2 months, and forward2 6 months
      let currentDate: Date = new Date();
      const currentDay = currentDate.getDay();

      if (currentDay !== 1) {
        currentDate = DateUtils.addDays(currentDate, -1 * (currentDay - 1));
      }
      // ok, moved to monday
      this.availableWeekStartDates = [];
      const looperDate = DateUtils.addDays(new Date(currentDate), -7 * previousWeeks);
      const weekRange: number = previousWeeks + forwardWeeks;
      for (let weekIdx: number = 0; weekIdx <= weekRange; weekIdx++) {
        this.availableWeekStartDates.push(new Date(DateUtils.addDays(looperDate, 7)));
      }
      // return the nearest previous monday
      return currentDate;
    }

    private goToPreviousWeek() {
      // get the index of the item in the available dates list, and substract 1
      // Cos dates are objects, the comparison never works. Need to map the dates to a number
      // and then compare that way: https://stackoverflow.com/a/27450967/281130
      const currentIdx = this.availableWeekStartDates.map(Number).indexOf(+this.selectedWeekStartDate);
      if (currentIdx > 0) {
        this.selectedWeekStartDate = this.availableWeekStartDates[currentIdx - 1];
      }
    }

    private goToNextWeek() {
      // get the index of the item in the available dates list, and substract 1
      // Cos dates are objects, the comparison never works. Need to map the dates to a number
      // and then compare that way: https://stackoverflow.com/a/27450967/281130
      const currentIdx = this.availableWeekStartDates.map(Number).indexOf(+this.selectedWeekStartDate);
      if (currentIdx < this.availableWeekStartDates.length - 1) {
        this.selectedWeekStartDate = this.availableWeekStartDates[currentIdx + 1];
      }
    }

    private updateBlock(id: string, newStatus: string, index: number) {
      const theBlock = this.blocks.find(b => b.id === id);
      if (theBlock !== undefined) {
        // Check if actually moving to a different date/column
        if (theBlock.savedStatus === newStatus) {
          // Just reordering within the same column - update sequence numbers
          // Wait for the DOM to update with the new order, then rebuild sequences
          this.$nextTick(() => {
            this.rebuildAndSaveSequencesForColumn(newStatus);
          });
          return;
        }
        
        // Store the pending move information and show confirmation dialog
        this.pendingMoveBlock = theBlock;
        this.pendingMoveNewStatus = newStatus;
        this.pendingMoveOldStatus = theBlock.savedStatus;
        this.$modal.show('modal-confirm-move');
      }
    }

    private getScheduledJobItems() {
      this.dataSourceScheduledJobItems = [];

      // Get the from and to dates from the stages as we have 
      // already calculated the correct range
      console.log('this.stages:', this.stages);
      const actualDateStages = this.stages.filter(stage => stage.date !== null).sort((a, b) => a.date!.getTime() - b.date!.getTime());
      const fromDate = DateUtils.toIsoDate(actualDateStages[0].date|| new Date());
      const toDate = DateUtils.toIsoDate(actualDateStages[actualDateStages.length - 1].date|| new Date());
      //let dr = new Date(this.selectedWeekStartDate);

      /* let dr: Date = new Date(this.selectedWeekStartDate);
      if (this.showFromToday) {
        // Check if the current date is in the same week as the selected week start date
        // and if so, use the current date as the reference date. Otherwise, use the selected week start date
        const currentDate = new Date();
        const currentWeek = DateUtils.getWeek(currentDate);
        const selectedWeek = DateUtils.getWeek(this.selectedWeekStartDate);
        if (currentWeek === selectedWeek) {
          dr = currentDate;
        }
      }
      // for my sanity, the '+' unary operator converts string to a number
      const fromDate: number = DateUtils.toIsoDate(dr);
      dr = DateUtils.addDays(dr, this.numberOfWeeksToDisplay * 7);
      const toDate: number = DateUtils.toIsoDate(dr); */

      const clientService: Client = new Client(process.env.VUE_APP_API_URL, this.$http);
      // @ts-ignore
      this.$Progress.start();
      clientService
        .getScheduledJobItems(fromDate, toDate, this.jobType)
        .then(data => {
          // @ts-ignore
          this.$Progress.finish();
          // push the items into the cache
          this.dataSourceScheduledJobItems = data;

          // Process the items into schedule items

          this.dataSourceScheduledJobItems.forEach(element => {
            // locate the existing item if there is one
            let newJobItem: JobScheduleItem = new JobScheduleItem();
            let currentItem: JobScheduleItem | null = null;

            const currentItems = this.blocks.filter(block => block.id === element.jobItemGid!);
            if (currentItems.length > 0) {
              currentItem = currentItems[0];
            }
            if (currentItem !== null) {
              newJobItem = currentItem;
            }

            newJobItem.id = element.jobItemGid!;
            // convert the scheduled date to the 'status' string
            if (element.scheduledDate !== undefined) {
              newJobItem.status = element.scheduledDate.toDateString();
              newJobItem.savedStatus = element.scheduledDate.toDateString();
              newJobItem.scheduledDate = element.scheduledDate;
            } else {
              newJobItem.status = 'unscheduled';
              newJobItem.savedStatus = 'unscheduled';
              newJobItem.scheduledDate = undefined;
            }
            newJobItem.title = element.name!;

            newJobItem.jobName = element.name!;
            newJobItem.jobItemName = element.itemName!;
            if (element.network !== undefined) {
              newJobItem.network = element.network.name!;
              newJobItem.networkGid = element.network.gid!;
              newJobItem.networkHexColor = '#' + element.network.hexColor!;
            }
            newJobItem.notes = element.notes!;
            newJobItem.jobGid = element.jobGid!;
            newJobItem.jobItemGid = element.jobItemGid!;
            newJobItem.jobItemScheduleGid = element.jobItemScheduleGid!;
            newJobItem.scheduledTimeRange = element.scheduledTimeRange!;

            if (element.serviceType !== undefined) {
              newJobItem.serviceType = element.serviceType.name!;
            }
            if (element.jobItemType !== undefined) {
              // @ts-ignore - the enums should cast OK between eachother despite the whinging by typescript
              newJobItem.jobItemType = element.jobItemType as JobItemType;
            }
            newJobItem.assignedToEmployee = element.assignedToEmployee!;
            newJobItem.assignedToEmployeeGid = element.assignedToEmployeeGid!;
            newJobItem.orderIndex = element.orderIndex;
            // Only push the item if it is new
            if (currentItem === null) {
              this.blocks.push(newJobItem);
            }
          });
          this.scheduledItemsLoaded = true;
          this.updateScheduleLoadStatus();
        })
        .catch((reason: any) => {
          // error loading the scheduled items
          this.scheduledItemsLoaded = true;
          this.updateScheduleLoadStatus();
        });
    }

    private getUnscheduledJobItems() {
      this.dataSourceUnscheduledJobItems = [];

      let dr = new Date(this.selectedWeekStartDate);

      // for my sanity, the '+' unary operator converts string to a number
      const st = dr.getFullYear() + ('0' + dr.getMonth()).slice(-2) + ('0' + dr.getDate()).slice(-2);
      const fromDate: number = DateUtils.toIsoDate(dr);
      dr = DateUtils.addDays(dr, this.numberOfWeeksToDisplay * 7);
      const toDate: number = DateUtils.toIsoDate(dr);

      const clientService: Client = new Client(process.env.VUE_APP_API_URL, this.$http);
      // @ts-ignore
      this.$Progress.start();
      clientService
        .getUnscheduledJobItems(fromDate, toDate, this.jobType)
        .then(data => {
          // @ts-ignore
          this.$Progress.finish();
          // push the items into the cache
          this.dataSourceUnscheduledJobItems = data;

          // Process the items into schedule items
          this.dataSourceUnscheduledJobItems.forEach(element => {
            // locate the existing item if there is one
            let newJobItem: JobScheduleItem = new JobScheduleItem();
            let currentItem: JobScheduleItem | null = null;
            const currentItems = this.blocks.filter(block => block.id === element.jobItemGid!);
            if (currentItems.length > 0) {
              currentItem = currentItems[0];
            }
            if (currentItem !== null) {
              newJobItem = currentItem;
            }

            newJobItem.id = element.jobItemGid!;
            newJobItem.status = 'unscheduled';
            newJobItem.savedStatus = 'unscheduled';
            newJobItem.title = element.name!;
            newJobItem.jobName = element.name!;
            newJobItem.jobItemName = element.itemName!;
            if (element.network !== undefined) {
              newJobItem.network = element.network.name!;
              newJobItem.networkGid = element.network.gid!;
              newJobItem.networkHexColor = '#' + element.network.hexColor!;
            }
            newJobItem.numberOfLots = 0;
            newJobItem.jobGid = element.jobGid!;
            newJobItem.jobItemGid = element.jobItemGid!;
            if (element.serviceType !== undefined) {
              newJobItem.serviceType = element.serviceType.name!;
            }
            if (element.jobItemType !== undefined) {
              // @ts-ignore - the enums should cast OK between eachother despite the whinging by typescript
              newJobItem.jobItemType = element.jobItemType as JobItemType;
            }

            // Only push the item if it is new
            if (currentItem === null) {
              this.blocks.push(newJobItem);
            }
          });
          this.unscheduledItemsLoaded = true;
          this.updateScheduleLoadStatus();
        })
        .catch((reason: any) => {
          // error loading the scheduled items
          this.unscheduledItemsLoaded = true;
          this.updateScheduleLoadStatus();
        });
    }

    private applyJobItemFilter() {
      this.filteredBlocks = this.blocks.filter(block => this.meetsFilterCriteria(block));
    }
    private meetsFilterCriteria(block: JobScheduleItem) {
      if (this.jobType !== 0) {
        if (block.jobItemType !== this.jobType) {
          return false;
        }
      }
      if (this.selectedNetwork !== '') {
        if (block.networkGid !== this.selectedNetwork) {
          return false;
        }
      }
      if (this.selectedEmployee !== '') {
        if (block.assignedToEmployeeGid !== this.selectedEmployee) {
          return false;
        }
      }

      return true;
    }
    private unscheduleJobItem(item: JobScheduleItem): Promise<any> {
      // Remove the current scheduling from the item
      // @ts-ignore
      this.$Progress.start();
      // set the new status immediately so there is no lag
      const previousStatus: string = item.status;
      const previousSavedStatus: string = item.savedStatus;
      item.status = 'unscheduled';

      const clientService: Client = new Client(process.env.VUE_APP_API_URL, this.$http);
      return clientService
        .unscheduleJobItem(item.jobGid, item.jobItemGid, item.jobItemScheduleGid)
        .then(data => {
          // process completed
          // Update savedStatus to reflect the successful save
          item.savedStatus = 'unscheduled';
          // don't show any updates I don't think in prod, but might be nice if dev
          // @ts-ignore
          this.$Progress.finish();
          // @ts-ignore
          this.$awn.success('Job successfully unscheduled.');
          return data;
        })
        .catch((reason: any) => {
          // @ts-ignore
          this.$Progress.fail();

          // @ts-ignore
          this.$awn.alert('Failed to unschedule the job. Reverting...\r\n' + reason.message);
          item.status = previousStatus;
          item.savedStatus = previousSavedStatus;
          throw reason;
        });
    }

    private scheduleJobItem(item: JobScheduleItem, newStatus: string): Promise<any> {
      // Set the current scheduling for the item
      // @ts-ignore
      this.$Progress.start();

      // set the new status immediately so there is no lag
      const previousStatus: string = item.status;
      const previousSavedStatus: string = item.savedStatus;
      item.status = newStatus;

      const clientService: Client = new Client(process.env.VUE_APP_API_URL, this.$http);
      const updateModel: JobItemUpdateScheduleModel = new JobItemUpdateScheduleModel();
      updateModel.jobItemGid = item.jobItemGid;
      updateModel.jobItemScheduleGid = item.jobItemScheduleGid || Guid.create().toString();
      const newScheduledDate: Date = new Date(newStatus);
      updateModel.scheduledDateISO = DateUtils.toIsoDate(newScheduledDate);
      updateModel.estimatedTravelTimeInMinutes = 0;
      updateModel.estimatedDurationInMinutes = 0;
      updateModel.scheduledTimeRange = item.scheduledTimeRange;
      updateModel.assignedToEmployeeGid = item.assignedToEmployeeGid || undefined;

      return clientService
        .scheduleJobItem(item.jobGid, item.jobItemGid, updateModel)
        .then(data => {
          // update the current item with the new values
          item.jobItemScheduleGid = data.gid!;
          item.scheduledTimeRange = data.scheduledTimeRange!;
          // Update savedStatus to reflect the successful save
          item.savedStatus = newStatus;

          // @ts-ignore
          this.$Progress.finish();
          // @ts-ignore
          this.$awn.success('Job successfully scheduled.');
          return data;
        })
        .catch(reason => {
          // @ts-ignore
          this.$Progress.fail();
          // @ts-ignore
          this.$awn.alert('Failed to schedule the job. Reverting...\r\n' + reason.message);
          item.status = previousStatus;
          item.savedStatus = previousSavedStatus;
          throw reason;
        });
    }

    private onJobItemScheduleAssignmentRequested(schedule: JobScheduleItem) {
      this.jobItemScheduleInAssignment = schedule;
      this.$modal.show('modal-schedule-assign-employee');
    }

    private onJobItemScheduleAssignmentUpdated(message: IJobItemScheduleModel) {
      // if ((message !== null) && (message.data !== null)) {
      //     const locatedItem = this.blocks.find(b => b.jobItemScheduleGid === message.data.gid);
      // }
      if (message !== null) {
        const locatedItem: JobScheduleItem | undefined = this.blocks.find(b => b.jobItemScheduleGid === message.gid);
        if (locatedItem !== undefined) {
          locatedItem.assignedToEmployeeGid = message.assignedToEmployeeGid || '';
          if (message.assignedToEmployee !== undefined) {
            locatedItem.assignedToEmployee =
              message.assignedToEmployee.firstName + ' ' + message.assignedToEmployee.lastName;
          } else {
            locatedItem.assignedToEmployee = '';
          }
        }
      }
    }

    private onJobItemScheduleRescheduleRequested(schedule: JobScheduleItem) {
      // Load the actual jobitemschedule object first
      const clientService: Client = new Client(process.env.VUE_APP_API_URL, this.$http);
      clientService
        .getJobItemSchedule(schedule.jobGid, schedule.jobItemGid, schedule.jobItemScheduleGid)
        .then(data => {
          // update the current item with the new values
          this.jobItemScheduleInReschedule = data;
          this.jobItemGidInReschedule = schedule.jobItemGid;
          this.jobGidInReschedule = schedule.jobGid;
          this.$modal.show('modal-jobitem-reschedule');
        })
        .catch(reason => {
          // @ts-ignore
          this.$awn.alert('Failed to load the current schedule. \r\n' + reason.message);
        });
    }

    private onJobItemRescheduled(schedule: IJobItemScheduleModel) {

      if (schedule !== null) {
        const locatedItem: JobScheduleItem | undefined = this.blocks.find(b => b.jobItemScheduleGid === schedule.gid);
        if (locatedItem !== undefined) {
          // Update the time range
          locatedItem.scheduledTimeRange = schedule.scheduledTimeRange!;
          // Update the status
          if (schedule.scheduledDate !== undefined) {
            locatedItem.status = schedule.scheduledDate.toDateString();
          } else {
            // Move the item to the unassigned column
            locatedItem.status = 'unscheduled';
          }
        }
      }
    }

    private onJobItemCancelRequested(schedule: JobScheduleItem) {
      const clientService: Client = new Client(process.env.VUE_APP_API_URL, this.$http);
      clientService
        .getJobItemSchedule(schedule.jobGid, schedule.jobItemGid, schedule.jobItemScheduleGid)
        .then(data => {
          // update the current item with the new values
          this.jobItemScheduleInCancel = data;
          this.jobItemGidInCancel = schedule.jobItemGid;
          this.jobGidInCancel = schedule.jobGid;
          this.jobItemNameInCancel = schedule.jobName;
          this.$modal.show('modal-jobitem-cancel');
        })
        .catch(reason => {
          // @ts-ignore
          this.$awn.alert('Failed to load the current schedule. \r\n' + reason.message);
        });
    }
    private onJobItemCancelled(jobItem: IJobItemModel) {
      
      // Find the block in the blocks array that matches the cancelled job item
      const blockIndex = this.blocks.findIndex(block => block.id === jobItem.gid || block.jobItemGid === jobItem.gid);
      
      if (blockIndex !== -1) {
        const cancelledBlock = this.blocks[blockIndex];
        const cancelledStatus = cancelledBlock.status;
        
        // Remove the cancelled item from the blocks array
        this.blocks.splice(blockIndex, 1);
        
        // Rebuild filteredBlocks to update the kanban board
        this.applyJobItemFilter();  
        
        // Rebuild sequences for the column that had the cancelled item (if it was scheduled)
        if (cancelledStatus !== 'unscheduled' && cancelledBlock.jobItemScheduleGid) {
          this.$nextTick(() => {
            this.rebuildAndSaveSequencesForColumn(cancelledStatus);
          });
        }
      }
    }

    private onConfirmMove() {
      this.$modal.hide('modal-confirm-move');
      if (this.pendingMoveBlock !== null) {
        const oldStatus = this.pendingMoveOldStatus;
        const newStatus = this.pendingMoveNewStatus;
        
        // either schedule or unschedule the item
        if (this.pendingMoveNewStatus === 'unscheduled') {
          // Unschedule the block
          this.unscheduleJobItem(this.pendingMoveBlock).then(() => {
            // After moving, rebuild sequences for the new column
            this.$nextTick(() => {
              this.rebuildAndSaveSequencesForColumn(newStatus);
            });
          });
        } else {
          this.scheduleJobItem(this.pendingMoveBlock, this.pendingMoveNewStatus).then(() => {
            // After moving to new column, rebuild sequences for the new column
            this.$nextTick(() => {
              this.rebuildAndSaveSequencesForColumn(newStatus);
            });
          });
        }
        // Clear pending state
        this.pendingMoveBlock = null;
        this.pendingMoveNewStatus = '';
        this.pendingMoveOldStatus = '';
      }
    }

    private onCancelMove() {
      this.$modal.hide('modal-confirm-move');
      // Revert the block to its original saved status
      if (this.pendingMoveBlock !== null) {
        this.pendingMoveBlock.status = this.pendingMoveBlock.savedStatus;
        
        // Force a complete refresh by clearing and rebuilding filteredBlocks
        // This ensures the kanban board completely re-renders with correct positions
        this.filteredBlocks = [];
        this.$nextTick(() => {
          this.applyJobItemFilter();
        });
        
        // Clear pending state
        this.pendingMoveBlock = null;
        this.pendingMoveNewStatus = '';
        this.pendingMoveOldStatus = '';
      }
    }

    get moveConfirmationMessage(): string {
      if (this.pendingMoveBlock === null) {
        return '';
      }
      const oldDate = this.pendingMoveOldStatus === 'unscheduled' ? 'Unscheduled' : new Date(this.pendingMoveOldStatus).toDateString();
      const newDate = this.pendingMoveNewStatus === 'unscheduled' ? 'Unscheduled' : new Date(this.pendingMoveNewStatus).toDateString();
      return `Move "${this.pendingMoveBlock.jobName}" from ${oldDate} to ${newDate}?`;
    }

    /**
     * Rebuilds sequence numbers for all blocks in a specific column/status and saves them to the server.
     * The blocks are ordered by their current position in filteredBlocks, which reflects the kanban board order.
     */
    private rebuildAndSaveSequencesForColumn(status: string): void {
      // Get all blocks in this column from filteredBlocks (they're already in the correct order from kanban)
      // filteredBlocks contains references to the same objects in blocks, so updating them updates both arrays
      const columnBlocks = this.filteredBlocks.filter(block => block.status === status && block.jobItemScheduleGid);
      
      // Skip if no blocks with schedule GIDs in this column
      if (columnBlocks.length === 0) {
        return;
      }
      //console.log('About to update order index for column blocks: ', columnBlocks);
      // Update orderIndex based on current position (1-based indexing)
      columnBlocks.forEach((block, index) => {
        block.orderIndex = index + 1;
        //console.log('Updating order index for block: ' + block.jobName + ' to order index: ' + block.orderIndex);
      });

      // Create sequence models for API call
      const sequenceModels: JobItemScheduleSequenceModel[] = columnBlocks.map(block => {
        const sequenceModel = new JobItemScheduleSequenceModel();
        sequenceModel.gid = block.jobItemScheduleGid;
        sequenceModel.orderIndex = block.orderIndex!;
        return sequenceModel;
      });

      // Save sequences to server
      const clientService = new Client(process.env.VUE_APP_API_URL, this.$http);
      clientService
        .updateJobItemScheduleSequence(sequenceModels)
        .then(() => {
          //console.log(`Successfully updated sequences for ${columnBlocks.length} items in column: ${status}`);
        })
        .catch((reason: any) => {
          console.error('Failed to update sequences:', reason);
          // @ts-ignore
          this.$awn.alert('Failed to save sequence order. Please refresh the page.\r\n' + reason.message);
        });
    }
  }
